var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.974 14.9507C10.8693 12.8427 10.4491 10.8205 9.7422 9.2299C9.68617 9.10383 9.62768 8.97928 9.56677 8.85668C10.2612 7.6592 11.1155 7 12 7C13.0609 7 14.0783 7.94821 14.8284 9.63604C15.4731 11.0865 15.875 12.9812 15.9753 15.0003C16.0027 15.5519 15.5523 16 15 16H12H10.7276C10.9004 15.6954 10.9932 15.3377 10.974 14.9507ZM9.00136 16C9.553 15.9992 10.0026 15.5514 9.97522 15.0003C9.87495 12.9812 9.47305 11.0865 8.82839 9.63604C8.07825 7.94822 7.06084 7.00001 5.99998 7C4.93913 7.00001 3.92172 7.94822 3.17158 9.63604C2.52691 11.0865 2.12502 12.9812 2.02475 15.0003C1.99907 15.5174 2.39327 15.9436 2.89769 15.9948C2.93132 15.9982 2.96544 16 2.99996 16M3.00001 16L6.00001 16H8.99996C9.00043 16 9.00089 16 9.00136 16",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c8020311ac87918f5bab9bee27047306.svg";
export { ForwardRef as ReactComponent };